var _defs, _line, _line2, _path, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconRecentArrowLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tick_empty",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .recentarrow {\n        fill: currentColor;\n      }\n\n      .recentarrow, .recentline {\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .recentline {\n        fill: none;\n      }\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "recentline",
    x1: 24.99,
    y1: 24.99,
    x2: 24.99,
    y2: 14.57
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "recentline",
    x1: 24.99,
    y1: 24.99,
    x2: 34.37,
    y2: 34.37
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "recentline",
    d: "M6.42,34.09c3.38,6.95,10.51,11.74,18.75,11.74,11.51,0,20.84-9.33,20.84-20.84,0-11.51-9.33-20.84-20.84-20.84-7.74,0-14.49,4.22-18.08,10.48"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "recentarrow",
    points: "6.06 7.28 6.06 15.68 13.72 15.68 6.06 7.28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconRecentArrowLine);
export default __webpack_public_path__ + "static/media/cloud_icon_recent_arrow_line.ec0c118db51b123757d9c99adf1fabd4.svg";
export { ForwardRef as ReactComponent };